import isBrowserContext from "helpers/isBrowserContext";
import { useState, useEffect } from "react";

function getWindowDimensions() {
    const w = isBrowserContext() ? window : undefined;

    return {
        width: w?.innerWidth ?? 1280,
        height: w?.innerHeight ?? 1024
    };
}

export default (): { width: number, height: number } => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
};